export class HRCareer {
    id:                   string;
    hrConfigId:           string;
    ownerEmployeeId:      string;
    title:                string;
    description:          string;
    active:               boolean = true;
}